import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OrganizationSelectionService {
  private readonly orgIdSubject = new BehaviorSubject<number | null>(null);
  readonly orgId$ = this.orgIdSubject.asObservable();
  private readonly isMyCaseOnlySubject = new BehaviorSubject<boolean>(false);
  readonly isMyOnlyView$ = this.isMyCaseOnlySubject.asObservable();
  private readonly parentOrgIdSubject = new BehaviorSubject<number | null>(
    null
  );
  readonly parentOrgId$ = this.parentOrgIdSubject.asObservable();

  setOrgId(id: number | null): void {
    this.orgIdSubject.next(id);
  }
  setIsMyOnlyView(isMyOnlyView: boolean): void {
    this.isMyCaseOnlySubject.next(isMyOnlyView);
  }

  setParentOrgId(id: number | null): void {
    this.parentOrgIdSubject.next(id);
  }

  get currentOrgId(): number | null {
    return this.orgIdSubject.getValue();
  }

  get currentIsMyCaseOnly(): boolean {
    return this.isMyCaseOnlySubject.getValue();
  }
}
